import React from "react";
import PropTypes from "prop-types";
import Image from "@components/image";
import XSlider from "@components/x-slider";

export default function BannerSlider({ slides }) {
  return slides && slides.length > 0 ? (
    <XSlider
      slides={slides}
      onRenderSlide={(slide, isCurrent, k) => (
        <a
          href={slide.url === "/" ? "javascript:;" : slide.url}
          target="_blank"
          className="f f--banner-item"
          data-key={k}
          data-ad-id={slide.adDeliveryId}
        >
          <Image src={slide.imageUrl} loadit={isCurrent} />
        </a>
      )}
    />
  ) : null;
}

BannerSlider.propTypes = {
  slides: PropTypes.array,
};

BannerSlider.defaultProps = {
  slides: [],
};

require("./index.less");
require("./index.less");